import React from 'react';
import ceoImage from '../asset/ceoImage.jpeg'; 

const CeoSection = ({ name, position, description }) => {
  return (
    <section className="ceo">
      <div className="ceo">
        <h3>{name} <span className="position">{position}</span></h3>
      </div>
      <div className="ceo-profile-img-container">
        <img src={ceoImage} className="ceo-profile-img-container" alt="CEO Img" />
      </div>
      <div className="ceo-info">
        <p style={{paddingTop: '50px'}} >{description}</p>
      </div>
    </section>
  );
}

export default CeoSection;
